// Function to generate dynamic lineChartData
export const generateLineChartData = (revenueData, profitData) => {
  return [
    {
      
      name: "Tokens",
      data: revenueData,
      color: "#2369d2",
    },
  ];
};

// Function to generate dynamic lineChartOptions
export const generateLineChartOptions = (categories) => {
  return {
    colors: ["#2369d2"],
    legend: {
      show: false,
    },
    theme: {
      mode: "light",
    },
    chart: {
      type: "line",
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      }
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth", // Changed to smooth
      width: 2, // Make line thinner
      type: "line",
      colors: ["#2369d2"] // Explicitly set line color
    },
    tooltip: {
      style: {
        fontSize: "12px",
        fontFamily: "Figtree, sans-serif", // Use project font
      },
      theme: "dark", // Use light theme for a cleaner look
      x: {
        format: "dd MMM",
      },
    },
    grid: {
      show: true,
      borderColor: '#e0e0e0',
      strokeDashArray: 5,
      yaxis: {
        lines: {
          show: true,
        },
      },
      xaxis: {
        lines: {
          show: false,
        },
      },
      padding: {
        top: 5,
        right: 20,
        bottom: 5,
        left: 20
      },
    },
    xaxis: {
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        style: {
          colors: "#525252",
          fontSize: "12px",
          fontWeight: "500",
          fontFamily: "Figtree, sans-serif",
        },
        formatter: function(value) {
          if (value) {
            const date = new Date(value);
            return date.getDate().toString();
          }
          return value;
        }
      },
      type: "text",
      categories: categories,
      title: {
        text: `${new Date().toLocaleString('default', { month: 'long' })} ${new Date().getFullYear()}`,
        style: {
          color: "#525252",
          fontSize: "14px",
          fontWeight: "600",
          fontFamily: "Figtree, sans-serif",
        },
      },
    },
    yaxis: {
      show: true,
      min: 0,
      max: 100,
      tickAmount: 4,
      labels: {
        style: {
          colors: "#525252",
          fontSize: "12px",
          fontFamily: "Figtree, sans-serif",
        },
        formatter: function (value) {
          return value.toFixed(0);
        },
      },
    },
  };
};

// Example of dynamic data
const dynamicRevenueData = [0, 4, 3, 0, 0, 4,2,0,4,3,0,4,4,3,3,0,0,0,0,0,2,2,2,1,3,3,0,4,2,1,];
const dynamicProfitData = [30, 40, 24, 46, 20, 46];
const dynamicCategories = [1, 2, 3, 4, 5, 6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30];

export const lineChartDataTotalSpent = generateLineChartData(
  dynamicRevenueData,
  dynamicProfitData
);
export const lineChartOptionsTotalSpent =
  generateLineChartOptions(dynamicCategories);
